import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { createAppQueryClient } from "./api/queryClient";
import { appRoutes } from "./App";
import { followDeviceTheme } from "./lib/theme";
import "@convenor/design-system/tokens.css";
import "@convenor/design-system/base.css";
import "@convenor/design-system/components.css";
import "./styles/base.css";
// The app's own sheets still waiting for their screens to move (see the files):
import "./ui/Layout.css";
import "./ui/StatusBadge.css";

followDeviceTheme();

const queryClient = createAppQueryClient();

// A data router, so pages can warn before in-app navigation drops unsaved
// changes (useBlocker).
const router = createBrowserRouter(appRoutes);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
